









import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import HeroBanner from '@shared/components/HeroBanner/HeroBanner.vue';
import { storyblokAssetToImage } from '@shared/helpers/storyblok/storyblokAssetToImage';
import { ISBAsset } from '@shared/types/storyblok';

export default defineComponent({
  name: 'StoryblokHeroBanner',
  components: {
    HeroBanner,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    // eslint-disable-next-line vue/prop-name-casing
    banner_image: {
      type: Object as PropType<ISBAsset>,
      default: () => ({}),
    },
    // eslint-disable-next-line vue/prop-name-casing
    banner_image_mobile: {
      type: Object as PropType<ISBAsset>,
      default: () => ({}),
    },
  },
  setup(props) {
    const bannerImage = computed(() => storyblokAssetToImage(props.banner_image));
    const bannerImageMobile = computed(() => storyblokAssetToImage(props.banner_image_mobile));

    return {
      bannerImage,
      bannerImageMobile,
    };
  },
});
